module.exports = __webpack_public_path__ + "img/trust-down-bg1.2e297da1.png";